import { MUTATION_TYPES } from "./mutationTypes";
import Vue from 'vue';
import Vuex from 'vuex';
import { MosaicId, MosaicProperties, MosaicTransferable, XEM } from "nem-library";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const sendDefault = {};
export default new Vuex.Store({
    state: {
        returnPath: "",
        calculatorFormula: '0',
        calculatorValue: 0,
        receiverAddress: '',
        receiverPublicKey: '',
        sendMosaics: sendDefault,
        sendMessage: '',
        usesMessageEncryption: false,
        backPathFromWalletSelect: '',
        backPathFromLesson: '',
        backPathFromKey: '',
        backPathFromSendConfirmation: '',
        transaction: null,
    },
    mutations: {
        [MUTATION_TYPES.SET_CALCULATOR_FORMULA](state, value) {
            state.calculatorFormula = value;
        },
        [MUTATION_TYPES.APPEND_CALCULATOR_FORMULA](state, value) {
            if (state.calculatorFormula === '0' && isFinite(Number(value))) {
                state.calculatorFormula = value;
            }
            else {
                state.calculatorFormula += value;
            }
        },
        [MUTATION_TYPES.DROP_CALCULATOR_FORMULA](state) {
            if (state.calculatorFormula.length <= 1) {
                state.calculatorFormula = '0';
            }
            else {
                state.calculatorFormula = state.calculatorFormula.slice(0, -1);
            }
        },
        [MUTATION_TYPES.CLEAR_CALCULATOR_FORMULA](state) {
            state.calculatorFormula = '0';
        },
        [MUTATION_TYPES.SET_CALCULATOR_VALUE](state, value) {
            state.calculatorValue = value;
        },
        [MUTATION_TYPES.SET_RECEIVER_ADDRESS](state, address) {
            state.receiverAddress = address;
        },
        [MUTATION_TYPES.CLEAR_RECEIVER_ADDRESS](state) {
            state.receiverAddress = '';
        },
        [MUTATION_TYPES.SET_RECEIVER_PUBLIC_KEY](state, publicKey) {
            state.receiverPublicKey = publicKey;
        },
        [MUTATION_TYPES.CLEAR_RECEIVER_PUBLIC_KEY](state) {
            state.receiverPublicKey = '';
        },
        [MUTATION_TYPES.ADD_SEND_MOSAIC](state, mosaic) {
            state.sendMosaics[mosaic.mosaicId.description()] = mosaic;
        },
        [MUTATION_TYPES.REMOVE_SEND_MOSAIC](state, name) {
            delete state.sendMosaics[name];
        },
        [MUTATION_TYPES.CLEAR_SEND_MOSAIC](state) {
            for (let key in state.sendMosaics) {
                delete state.sendMosaics[key];
            }
            Object.assign(state.sendMosaics, sendDefault);
            const xem = new XEM(0);
            state.sendMosaics[xem.mosaicId.description()] = xem;
        },
        [MUTATION_TYPES.SET_SEND_MESSAGE](state, message) {
            state.sendMessage = message;
        },
        [MUTATION_TYPES.CLEAR_SEND_MESSAGE](state) {
            state.sendMessage = '';
        },
        [MUTATION_TYPES.SET_MESSAGE_ENCRYPTION](state, usesEncryption) {
            state.usesMessageEncryption = usesEncryption;
        },
        [MUTATION_TYPES.SET_BACK_PATH_FROM_WALLET_SELECT](state, backPath) {
            state.backPathFromWalletSelect = backPath;
        },
        [MUTATION_TYPES.SET_BACK_PATH_FROM_LESSON](state, backPath) {
            state.backPathFromLesson = backPath;
        },
        [MUTATION_TYPES.SET_BACK_PATH_FROM_KEY](state, backPath) {
            state.backPathFromKey = backPath;
        },
        [MUTATION_TYPES.SET_BACK_PATH_FROM_SEND_CONFIRMATION](state, backPath) {
            state.backPathFromSendConfirmation = backPath;
        },
        [MUTATION_TYPES.SET_TRANSACTION](state, transaction) {
            state.transaction = transaction;
        },
        [MUTATION_TYPES.SETUP_TYPES](state) {
            let nonTypedMap = state.sendMosaics;
            const mosaics = {};
            for (let key of Object.keys(nonTypedMap)) {
                const nonTypedTransferable = nonTypedMap[key];
                const mosaicId = new MosaicId(nonTypedTransferable.mosaicId.namespaceId, nonTypedTransferable.mosaicId.name);
                const properties = Object.assign(new MosaicProperties(), nonTypedTransferable.properties);
                mosaics[key] = new MosaicTransferable(mosaicId, properties, nonTypedTransferable.amount);
            }
            state.sendMosaics = mosaics;
        }
    },
    plugins: [createPersistedState()]
});



//////////////////
// WEBPACK FOOTER
// ./src/lib/store.ts
// module id = 1619
// module chunks = 1